// Small pieces of turning a form's value into what is sent.

// Text trimmed, and nothing at all (null) when it is blank. Anything else is read as text first, so a number is kept as one.
export function nullIfBlank(value: unknown): string | null {
  return String(value ?? '').trim() || null;
}

// Trims every text in a record (blank text becomes null), and does the same inside the rows of a list.
export function cleanRecord<T extends Record<string, unknown>>(value: T): T {
  return Object.fromEntries(
    Object.entries(value).map(([key, entry]) => {
      if (typeof entry === 'string') return [key, nullIfBlank(entry)];
      if (Array.isArray(entry)) {
        return [key, entry.map((row) => (row !== null && typeof row === 'object' ? cleanRecord(row as Record<string, unknown>) : row))];
      }

      return [key, entry];
    }),
  ) as T;
}
